import { createError } from 'apollo-errors';

export const AuthenticationRequiredError = createError(
  'AuthenticationRequiredError',
  {
    message: 'You must be logged in',
  },
);

export const RequestFailureError = createError('RequestFailureError', {
  message: 'The request was made but no response was received',
});

export const UnknownResponseError = createError('UnknownResponseError', {
  message:
    'Something happened in setting up the request that triggered an error',
});

export const handleGeneralError = (message) => {
  const GeneralError = createError('GeneralError', {
    message,
  });

  throw new GeneralError();
};

export const handleHttpErrors = (err) => {
  const ResponseError = createError('RepsonseError', {
    message: `${err.response.status}:${err.response.data.error.message}`,
  });

  throw new ResponseError();
};

export const RolesError = (err) => {
  const RolesHandlerError = createError('RolesHandlerError', {
    message: err.message,
  });

  throw new RolesHandlerError();
};

export default {
  AuthenticationRequiredError,
  RequestFailureError,
  UnknownResponseError,
  handleGeneralError,
  handleHttpErrors,
  RolesError,
};
